import { byPrefixAndName } from '@awesome.me/kit-5c288c4b3f/icons'
import { IconName } from '@awesome.me/kit-5c288c4b3f/icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'gatsby'
import React from 'react'
import { classNames } from '../utils'
import { buttonStyles } from './buttonStyles'

interface ButtonProps {
  activeClassName?: string
  airplane?: boolean
  children?: React.ReactNode
  customClasses?: string
  icon?: IconName
  onClick?: () => void
  partiallyActive?: boolean
  play?: boolean
  rel?: string
  search?: boolean
  size?: 'small' | 'medium' | 'large' | 'xl' | 'xxl'
  target?: string
  to?: string
  twoIcons?: boolean
  variant?: 'primary' | 'secondary' | 'default' | 'outline'
}

// This button can act like a normal <a> tag or use GatsbyLink component for routing

// Since DOM elements <a> cannot receive activeClassName
// and partiallyActive, destructure the prop here and
// pass it only to GatsbyLink
export const Button = ({
  children,
  to,
  activeClassName,
  customClasses,
  partiallyActive,
  variant = 'default',
  icon,
  size = 'medium',
  ...other
}: ButtonProps) => {
  // Tailor the following test to your environment.
  // This example assumes that any internal link (intended for Gatsby)
  // will start with exactly one slash, and that anything else is external.
  const internal = /^\/(?!\/)/.test(to)

  // Use Gatsby Link for internal links, and <a> for others
  if (internal) {
    return (
      <Link
        className={classNames(
          'btn',
          buttonStyles[size].base,
          `btn-${variant}`,
          customClasses,
          'focus-visible:outline-default-50'
        )}
        to={to}
        activeClassName="active"
        partiallyActive={partiallyActive}
        {...other}
      >
        {icon && <FontAwesomeIcon icon={byPrefixAndName.fad[icon]} />}
        {children}
        <FontAwesomeIcon
          transform="grow-6"
          icon={byPrefixAndName.fal['angle-right']}
        />
      </Link>
    )
  }
  return (
    <a
      href={to}
      className={classNames(
        'btn',
        buttonStyles[size].base,
        `btn-${variant}`,
        customClasses,
        'focus-visible:outline-default-50'
      )}
      {...other}
    >
      {icon && <FontAwesomeIcon icon={byPrefixAndName.fad[icon]} />}
      {children}
      <FontAwesomeIcon
        transform="grow-6"
        icon={byPrefixAndName.fal['angle-right']}
      />
    </a>
  )
}
